(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["g-photo-strip"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('g-photo-strip')) {
    customElements.define('g-photo-strip', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal:this.controller.signal };
        this.viewport = this.querySelector('.g-photo-strip__viewport');
        this.track = this.querySelector('.g-photo-strip__track');
        this.button = this.querySelector('button');
        this.originals = Array.from(this.track.children);
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.reduced.matches;
        this.holdUntil = 0;
        this.hovered = false;
        this.dragging = false;
        this.visible = false;
        this.position = 0;
        this.originals.forEach(item => {
          const clone = item.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('inert', '');
          clone.removeAttribute('data-shopify-editor-block');
          clone.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
          this.track.appendChild(clone);
        });
        this.measure = () => {
          const clone = this.track.children[this.originals.length];
          this.loopWidth = clone && this.originals[0] ? clone.getBoundingClientRect().left - this.originals[0].getBoundingClientRect().left : 0;
          this.canLoop = this.loopWidth > this.viewport.clientWidth;
          this.button.hidden = !this.canLoop;
          if (this.loopWidth) this.position %= this.loopWidth;
        };
        const updateButton = () => {
          this.button.setAttribute('aria-pressed', String(this.paused));
          this.button.setAttribute('aria-label', this.paused ? this.button.dataset.play : this.button.dataset.pause);
          this.button.firstElementChild.textContent = this.paused ? '▶' : 'Ⅱ';
        };
        this.button.addEventListener('click', () => { this.paused = !this.paused; updateButton(); }, options);
        this.reduced.addEventListener('change', () => { this.paused = this.reduced.matches; updateButton(); }, options);
        this.viewport.addEventListener('pointerdown', () => { this.dragging = true; }, options);
        const release = () => { this.dragging = false; this.holdUntil = performance.now() + 3000; };
        window.addEventListener('pointerup', release, options);
        window.addEventListener('pointercancel', release, options);
        this.viewport.addEventListener('wheel', () => { this.holdUntil = performance.now() + 3000; }, options);
        this.viewport.addEventListener('keydown', () => { this.holdUntil = performance.now() + 3000; }, options);
        this.addEventListener('pointerenter', e => { if(e.pointerType === 'mouse') this.hovered = true; }, options);
        this.addEventListener('pointerleave', () => { this.hovered = false; }, options);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; });
        this.observer.observe(this);
        this.resize = new ResizeObserver(this.measure);
        this.resize.observe(this.viewport);
        this.measure();
        updateButton();
        let previous = 0;
        const tick = now => {
          const elapsed = previous ? Math.min(now - previous, 40) : 0;
          previous = now;
          if(this.canLoop && this.visible && !document.hidden && !this.paused && !this.hovered && !this.dragging && now > this.holdUntil && !this.viewport.matches(':focus-visible')) {
            if (Math.abs(this.viewport.scrollLeft - this.position) > 2) this.position = this.viewport.scrollLeft;
            this.position = (this.position + elapsed * 0.025) % this.loopWidth;
            this.viewport.scrollLeft = this.position;
          } else {
            this.position = this.viewport.scrollLeft;
          }
          this.frame = requestAnimationFrame(tick);
        };
        this.frame = requestAnimationFrame(tick);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.controller?.abort();
        this.observer?.disconnect();
        this.resize?.disconnect();
        this.track?.querySelectorAll('[aria-hidden="true"]').forEach(el => el.remove());
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["g-video-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('g-video-carousel')) {
  customElements.define('g-video-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.track = this.querySelector('.gvc-track');
      this.prev = this.querySelector('.gvc-prev');
      this.next = this.querySelector('.gvc-next');
      this.abort = new AbortController();
      const opts = { signal: this.abort.signal };
      this.update = () => {
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        this.prev.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= max - 2;
      };
      this.move = direction => {
        const card = this.track.querySelector('.gvc-card');
        if (!card) return;
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0);
        this.track.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      this.prev.addEventListener('click', () => this.move(-1), opts);
      this.next.addEventListener('click', () => this.move(1), opts);
      this.track.addEventListener('scroll', this.update, { ...opts, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault(); this.move(event.key === 'ArrowRight' ? 1 : -1);
      }, opts);
      this.addEventListener('play', event => {
        if (event.target.tagName !== 'VIDEO') return;
        this.querySelectorAll('video').forEach(video => { if (video !== event.target) video.pause(); });
      }, { ...opts, capture: true });
      document.addEventListener('visibilitychange', () => { if (document.hidden) this.pauseAll(); }, opts);
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.gvc-card');
        if (card) this.track.scrollTo({ left: card.offsetLeft - this.track.offsetLeft, behavior: 'auto' });
      }, opts);
      this.resize = new ResizeObserver(this.update); this.resize.observe(this.track);
      this.visibility = new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting) entry.target.pause();
      }), { root: this.track, threshold: 0 });
      this.querySelectorAll('video').forEach(video => this.visibility.observe(video));
      this.update();
    }
    pauseAll() { this.querySelectorAll('video').forEach(video => video.pause()); }
    disconnectedCallback() { this.pauseAll(); this.abort?.abort(); this.resize?.disconnect(); this.visibility?.disconnect(); this.abort = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gleamify-before-after-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('g-comparison-panels')) customElements.define('g-comparison-panels', class extends HTMLElement {
  connectedCallback() {
    if (this.abort) return;
    this.abort = new AbortController(); const opts = {signal:this.abort.signal};
    this.mobile = matchMedia('(max-width: 749px)'); this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
    this.slides = Array.from(this.querySelectorAll('[data-panel]'));
    this.range = this.querySelector('[data-before-after-range]'); this.pause = this.querySelector('[data-g-pause]');
    this.dots = Array.from(this.querySelectorAll('[data-g-dot]')); this.index = 1;this.visible = false;
    this.stopped = this.dataset.autoplay !== 'true' || this.reduced.matches;
    this.select = index => {
      this.index = ((index - 1 + 3) % 3) + 1;
      const active = this.mobile.matches ? this.index : 0;
      this.slides.forEach((slide,i) => {slide.classList.toggle('is-active',i===active);slide.inert=i!==active;slide.setAttribute('aria-hidden',String(i!==active));});
      this.range.value = this.slides[active].style.getPropertyValue('--g-position').trim().replace('%','') || '52';
      this.dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i+1===this.index)));
    };
    this.schedule = () => {
      clearTimeout(this.timer);
      this.pause.textContent = this.stopped ? this.pause.dataset.play : this.pause.dataset.pause;
      if (!this.mobile.matches || this.stopped || this.reduced.matches || !this.visible || document.hidden || this.dragging || this.matches(':focus-within') || this.hovered) return;
      this.timer = setTimeout(()=>{this.select(this.index+1);this.schedule();},5000);
    };
    const manual = index => {this.stopped=true;this.select(index);this.schedule();};
    this.querySelector('[data-before-after-prev]').addEventListener('click',()=>manual(this.index-1),opts);
    this.querySelector('[data-before-after-next]').addEventListener('click',()=>manual(this.index+1),opts);
    this.dots.forEach((dot,i)=>dot.addEventListener('click',()=>manual(i+1),opts));
    this.range.addEventListener('input',()=>{this.stopped=true;this.slides[this.mobile.matches?this.index:0].style.setProperty('--g-position',this.range.value+'%');this.schedule();},opts);
    this.range.addEventListener('pointerdown',()=>{this.dragging=true;this.schedule();},opts);
    document.addEventListener('pointerup',()=>{this.dragging=false;this.schedule();},opts);
    document.addEventListener('pointercancel',()=>{this.dragging=false;this.schedule();},opts);
    this.pause.addEventListener('click',()=>{this.stopped=!this.stopped;this.schedule();},opts);
    this.addEventListener('focusin',this.schedule,opts);this.addEventListener('focusout',()=>queueMicrotask(this.schedule),opts);
    this.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'){this.hovered=true;this.schedule();}},opts);
    this.addEventListener('pointerleave',()=>{this.hovered=false;this.schedule();},opts);
    this.mobile.addEventListener('change',()=>{this.select(this.index);this.schedule();},opts);
    this.reduced.addEventListener('change',this.schedule,opts);document.addEventListener('visibilitychange',this.schedule,opts);
    this.observer = new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.schedule();},{threshold:.15});this.observer.observe(this);
    this.select(1);this.schedule();
  }
  disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort();this.observer?.disconnect();this.abort=null;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
